import { render, staticRenderFns } from "./_base-scroll-view.vue?vue&type=template&id=e79ca712&"
import script from "./_base-scroll-view.vue?vue&type=script&lang=js&"
export * from "./_base-scroll-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports